// extracted by mini-css-extract-plugin
export default {"user":"styles_user__W6Wgs","name":"styles_name__eCst-","email":"styles_email__TLYDe","item":"styles_item__0YQnL","icon":"styles_icon__lHK2w","activeLink":"styles_activeLink__CcD6q"};